import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import {
  UsersQuery,
  UsersDocument,
  UserFilterInput,
  UserSortingInput,
  SortingDirection,
  Subjects,
  Actions,
  AppArea,
} from 'src/graphql/generated/graphql';
import { OtpFilter } from './filter';
import { OtpTable } from './table';
import { Routes } from 'src/components/common/router/constants';
import { TableWrapper } from 'src/components/common/wrapper/table/wrapper';
import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { FilterWrapper } from 'src/components/common/wrapper/filter/wrapper';
import { Can } from 'src/utils/can';
import { StoresByOtpProReportButton } from './stores-by-otp-pro-report-button';

const PAGINATION_LIMIT = 20;

export const ListOTP = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState<UserFilterInput>();
  const [sorting, setSorting] = useState<UserSortingInput>({
    lastName: SortingDirection.Asc,
  });
  const [sortingField, sortingDirection] = Object.entries(sorting)?.[0];

  const { loading, data } = useQuery<UsersQuery>(UsersDocument, {
    variables: {
      filter,
      sorting,
      pagination: {
        limit: PAGINATION_LIMIT,
        offset: page * PAGINATION_LIMIT,
      },
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
  });
  const totalCount = data?.users?.pagination?.totalCount;
  const users = data?.users?.records || [];

  const onFilterChange = (filter: UserFilterInput) => {
    setPage(0);
    setFilter(filter);
  };

  const onColumnSortChange = (
    changedColumn: string,
    direction: 'desc' | 'asc',
  ) => {
    const newSorting = {
      [changedColumn]:
        direction === 'desc' ? SortingDirection.Desc : SortingDirection.Asc,
    };
    setSorting(newSorting);
  };

  const onRowClick = (_: any, { rowIndex }: { rowIndex: number }) => {
    const user = users[rowIndex];
    navigate(`${Routes.users.path}/${user.id}`);
  };

  return (
    <Can I={Actions.Read} a={Subjects.Users} appArea={AppArea.Common}>
      <FilterWrapper>
        <OtpFilter onSubmit={onFilterChange} />
      </FilterWrapper>

      <ContentWrapper>
        <TableWrapper>
          <div className="flex justify-end gap-2 mb-2">
            <StoresByOtpProReportButton />
          </div>
          <OtpTable
            data={users}
            loading={loading}
            options={{
              page,
              count: totalCount,
              sort: true,
              onColumnSortChange,
              rowsPerPage: PAGINATION_LIMIT,
              onRowClick,
              onChangePage: setPage,
              sortOrder: {
                name: sortingField,
                direction:
                  sortingDirection === SortingDirection.Desc ? 'desc' : 'asc',
              },
            }}
          />
        </TableWrapper>
      </ContentWrapper>
    </Can>
  );
};
